import {removeCartItem} from "../api/common";

export function removeItem(authenticityToken, link) {
  fetch(removeCartItem(authenticityToken, link)).then(() =>
    window.location.reload()
  );
}
